import { CompanyAdminContact } from '@app/models/payroll/company/company-admin-contact';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class PhoneColumn extends Column {
    title = 'payroll.settings.phone';
    property = 'phone';
    sortable = false;
    type: CellDisplay = CellDisplay.string;

    getDisplayPropertyValue(contact: CompanyAdminContact): string {
        if (!contact.phone || contact.phone.length != 10) {
            return '';
        }
        const phone = contact.phone;
        return `(${phone.substring(0, 3)}) ${phone.substring(3, 6)}-${phone.substring(6)}`;
    }
}
